import React from 'react'
import { Slider } from '@mui/material';

export type Props = {
	name?: string
	value?: number,
	onChange?: Function,
    step: number,
    min: number,
    max: number,
}

export default function ModuleSaturationSettings(props: Props) {
	let stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	return <Slider name={props.name} onMouseDown={stopPropagation} onChange={(e:Event, v: any) => props.onChange(e, v)} value={props.value} step={props.step} min={props.min} max={props.max} />
}